import { render, staticRenderFns } from "./CustomerVendorContracts.vue?vue&type=template&id=4b358d8e&scoped=true"
import script from "./CustomerVendorContracts.vue?vue&type=script&lang=ts"
export * from "./CustomerVendorContracts.vue?vue&type=script&lang=ts"
import style0 from "./CustomerVendorContracts.vue?vue&type=style&index=0&id=4b358d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b358d8e",
  null
  
)

export default component.exports